export enum SubsidiaryIds {
  USA = "ILOQ_USA_INC",
  FINLAND = "ILOQ_OY",
}

// Alternative to the SubsidiaryIds enum
export const SubsidiaryId = {
  USA: "ILOQ_USA_INC",
  FINLAND: "ILOQ_OY",
} as const;

export type SubsidiaryId = (typeof SubsidiaryId)[keyof typeof SubsidiaryId];
